<template>
    <b-dropdown class="fert-method-dropdown" variant="transparent" no-caret>
        <template v-slot:button-content>
            <div class="selected-fert-method">
                <div>
                    {{ $translate(selectedMethodLabel) }}
                </div>
                <img :src="`/static/svg/well_status/DEFAULT.svg`" class="caret" alt="" />
            </div>
        </template>

        <b-dropdown-item
            v-for="option in dropdownOptions"
            :key="option"
            @click="selectInseminationMethod(option)"
        >
            {{ $translate(option) }}
        </b-dropdown-item>
    </b-dropdown>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import { WELL_STATUS_ICONS_PATH } from '../../../business/const'

export default {
    name: 'FertMethodDropdown',
    props: {
        defaultLabel: {
            type: String,
            required: true
        },
        well: {
            type: Object,
            default: () => null
        }
    },
    data() {
        return {
            WELL_STATUS_ICONS_PATH,
            allOptions: ['IVF', 'ICSI', 'PICSI', 'IMSI', 'PIMSI', 'NA'],
            selectedSlideId: '',
            selectedDefaultMethod: ''
        }
    },
    computed: {
        ...mapState({
            selectedSlide: state => state.timelapse.selectedSlide
        }),
        ...mapGetters({
            tenant: 'common/getTenant',
            activeSlideNonEmptyWells: 'timelapse/activeSlideNonEmptyWells'
        }),
        isSlideSideBar() {
            return !this.well
        },
        selectedInseminationMethod() {
            return this.well
                ? this.well.insemination && this.well.insemination.method
                : this.selectedDefaultMethod || this.tenant.settings.inseminationType
        },
        dropdownOptions() {
            return this.allOptions.filter(option => this.selectedInseminationMethod !== option)
        },
        selectedMethodLabel() {
            return this.isSlideSideBar
                ? this.selectedDefaultMethod ||
                      this.tenant.settings.inseminationType ||
                      this.defaultLabel
                : (this.well.insemination && this.well.insemination.method) || this.defaultLabel
        }
    },
    watch: {
        selectedSlide() {
            this.selectedDefaultMethod = ''
        }
    },
    methods: {
        selectInseminationMethod(selectedMethodLabel) {
            this.selectedDefaultMethod = selectedMethodLabel
            if (this.isSlideSideBar) {
                this.$mainController.updateWellsFertMethod(
                    this.activeSlideNonEmptyWells,
                    selectedMethodLabel
                )
            } else {
                this.$mainController.updateWellsFertMethod([this.well], selectedMethodLabel)
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.fert-method-dropdown {
    border: 1px solid $blue;
    border-radius: 0.3rem;
    padding: 0 0.5rem;
    color: $white;

    .dropdown-menu {
        li {
            margin-top: -0.2rem;
        }
    }
    .selected-fert-method {
        font-size: 0.75rem;
        display: flex;
        justify-content: space-between;
        background-color: transparent !important;

        .caret {
            height: 1rem;
        }
    }
}
</style>
<style lang="scss">
.dropdown-menu {
    min-width: auto;
}
</style>
